import { useAuth } from '../contexts/useAuth'
import { isAdminTierRole, isManagerTierRole } from '../lib/roles'

export function usePermissions() {
  const { permissions, user } = useAuth()
  const isAdmin = isAdminTierRole(user?.role)

  return {
    can: (permission: string) => isAdmin || permissions.includes(permission),
    canAny: (...perms: string[]) => isAdmin || perms.some((p) => permissions.includes(p)),
    canAll: (...perms: string[]) => isAdmin || perms.every((p) => permissions.includes(p)),
    isAdmin,
    isManager: isManagerTierRole(user?.role),
    role: user?.role ?? null,
  }
}
